import { Checkbox } from "@mui/material";
import styles from "./list.module.css";

const bookingIsPayable = (booking) => booking?.payment_status === 1 || booking?.payment_status === "1";

const isTruthy1 = (v) => v === 1 || v === "1";

// A single item can be assigned to a driver only if: the booking is paid,
// the item has actually arrived at the GH warehouse, and it isn't already
// out for delivery or delivered. Items still in transit (not yet shipped,
// or shipped but not yet received) stay visible but disabled.
export const isItemEligible = (item, booking) => {
    return bookingIsPayable(booking)
        && isTruthy1(item?.is_ship_received)
        && !isTruthy1(item?.is_out_for_delivery)
        && !isTruthy1(item?.is_deliverred);
};

export const eligibleItemIds = (booking) => (booking?.products || [])
    .filter((item) => isItemEligible(item, booking))
    .map((item) => item.id);

const statusFor2 = (item, booking) => {
    if (!bookingIsPayable(booking)) return { label: "Awaiting Payment", cls: "ItemStatusWaiting" };
    if (isTruthy1(item?.is_deliverred)) return { label: "Delivered", cls: "ItemStatusDone" };
    if (isTruthy1(item?.is_out_for_delivery)) return { label: "Out For Delivery", cls: "ItemStatusOut" };
    if (isTruthy1(item?.is_ship_received)) return { label: "Ready For Delivery", cls: "ItemStatusReady" };
    if (isTruthy1(item?.is_port_received)) return { label: "At Port", cls: "ItemStatusWaiting" };
    if (isTruthy1(item?.is_shipped)) return { label: "In Transit", cls: "ItemStatusWaiting" };
    return { label: "Not Yet Shipped", cls: "ItemStatusWaiting" };
};

const statusFor = (item, booking) => {
    if (!bookingIsPayable(booking)) return { label: "Awaiting Payment", cls: "ItemStatusWaiting" };
    if (isTruthy1(item?.is_deliverred)) {
        return {
            label: item?.delivery_driver?.name ? `Delivered by ${item.delivery_driver.name}` : "Delivered",
            cls: "ItemStatusDone"
        };
    }
    if (isTruthy1(item?.is_out_for_delivery)) {
        return {
            label: item?.delivery_driver?.name ? `Out For Delivery — ${item.delivery_driver.name}` : "Out For Delivery",
            cls: "ItemStatusOut"
        };
    }
    if (isTruthy1(item?.is_ship_received)) return { label: "Ready For Delivery", cls: "ItemStatusReady" };
    if (isTruthy1(item?.is_port_received)) return { label: "At Port — Awaiting Warehouse", cls: "ItemStatusWaiting" };
    if (isTruthy1(item?.is_shipped)) return { label: "In Transit", cls: "ItemStatusWaiting" };
    return { label: "Not Yet Shipped", cls: "ItemStatusWaiting" };
};

const BookingItemsPanel = ({ booking, selected, onToggleItem }) => {
    const items = booking?.products || [];

    if (items.length === 0) {
        return (<div className={styles.ItemPanel}>
            <p className={styles.ItemPanelHead}>No items found on this booking</p>
        </div>);
    }

    return (<div className={styles.ItemPanel}>
        <p className={styles.ItemPanelHead}>Items on this booking ({items.length})</p>
        {items.map((prod) => {
            const eligible = isItemEligible(prod, booking);
            const isChecked = selected.indexOf(prod.id) > -1;
            const status = statusFor(prod, booking);

            return (<div className={`${styles.ItemRow} ${!eligible ? styles.ItemRowDisabled : ""}`} key={prod.id}>
                <Checkbox
                    size="small"
                    color="primary"
                    checked={eligible && isChecked}
                    disabled={!eligible}
                    onChange={() => onToggleItem(prod.id)}
                />
                <div className={styles.ItemRowTitle}>
                    {prod?.product_title}
                    {prod?.container_name && prod.container_name !== " - " && (
                        <span className={styles.ItemRowMeta}> · Container {prod.container_name}</span>
                    )}
                </div>
                <span className={`${styles.ItemStatusTag} ${styles[status.cls]}`}>{status.label}</span>
            </div>);
        })}
    </div>);
};

export default BookingItemsPanel;